


// --- React Hooks & Router Imports ---
import React, { useState, useEffect, useRef, } from 'react';
import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box'; // Import Box for responsive sx prop
import PageWrapper from './PageWrapper'; // Import the new wrapper

import DonateComponent from 'centennial_refactor/components/donate/DonateComponent'


// --- NEW: Import styles from the dedicated style file ---




// this has the class 'section_style' / 'glow_border_class' / 'intro_heading_style'
import './style/style_centennial.css';
import 'fonts/font.css'; // Global font styles

import {
    colors,
    pageContainerStyles,
} from './PageStyles';


// import CollapsibleSectionNoBorder from 'pages_centennial/components/user_interface/CollapsibleSectionNoBorder';


// import CollapsibleSectionNoBorderNoButton from 'pages_centennial/components/user_interface/CollapsibleSectionNoBorderNoButton';





// used in section_01
import FadeInSectionText from 'pages_centennial/components/user_interface/FadeInSectionText'



import CollapsibleSection_01 from 'centennial_refactor/components/collapse/CollapsibleSection_01'








import { useNavigate } from 'react-router-dom';

import GODDARD_ROCKET from 'centennial_refactor/assets/goddard_rocket.png'

import PlayOnceVideo from 'pages_centennial/PlayOnceVideo';

import NewsletterForm from 'pages_public/NewsletterForm';

import CHARLES_SLATKIN_IMAGE_2 from 'assets/charles-slatkin-boy-square-image.jpg'
import CHARLES_SLATKIN_SIGNATURE from 'assets/charles-signature.png'















// 1007
import 'pages_centennial/style/style_centennial.css';

import {

    introBannerStyles3,

    StyledMissionList,
    StyledMissionListItem,
    StyledMissionListItemNested,


    introHeadingStyles,
    introSubHeadingStyles,


    squareBulletStyle,



} from './style/PageStylesCentennial';




import CollapsibleSectionNoBorder from 'pages_centennial/components/user_interface/CollapsibleSectionNoBorder';
import CollapsibleSectionNoBorder2 from 'pages_centennial/components/user_interface/CollapsibleSectionNoBorder2';
import CollapsibleSectionNoBorderNoButton from 'pages_centennial/components/user_interface/CollapsibleSectionNoBorderNoButton';

import CollapsibleSectionNoBorderExpanded from 'pages_centennial/components/user_interface/CollapsibleSectionNoBorderExpanded';
import CollapsibleSectionNoBorderCenter from 'pages_centennial/components/user_interface/CollapsibleSectionNoBorderCenter';
import CollapsibleSectionNoBorder3 from 'pages_centennial/components/user_interface/CollapsibleSectionNoBorder3';


// import GODDARD_IMAGE from 'pages_centennial/assets/goddard.jpg'
import CENTENNIAL_LOGO_2 from 'pages_centennial/assets/centennial_images-000.png'

import SLIDE_05 from 'pages_centennial/assets/slide_5.png'
import SLIDE_06 from 'pages_centennial/assets/slide_6.png'
import SLIDE_10 from 'pages_centennial/assets/slide_10.png'
import SLIDE_11 from 'pages_centennial/assets/slide_11.png'
import SLIDE_12 from 'pages_centennial/assets/slide_12.png'
import SLIDE_13 from 'pages_centennial/assets/slide_13.png'
import SLIDE_15 from 'pages_centennial/assets/slide_15.png'
import SLIDE_16 from 'pages_centennial/assets/slide_16.png'
import SLIDE_17 from 'pages_centennial/assets/slide_17.png'
import SLIDE_18 from 'pages_centennial/assets/slide_18.png'

import wm_cw_036 from 'pages_centennial/assets/wm_cw-036.png'
import wm_cw_104 from 'pages_centennial/assets/wm_cw-104.png'

import THE_CHALLENGE from 'pages_centennial/assets/the_challenge.jpeg'










import SLIDE_01_0819 from 'pages_centennial/assets/0828/0819_SLIDE_01.png'
import SLIDE_02_0819 from 'pages_centennial/assets/0828/0819_SLIDE_02.png'
import SLIDE_03_0819 from 'pages_centennial/assets/0828/0819_SLIDE_03.png'
import SLIDE_04_0819 from 'pages_centennial/assets/0828/0819_SLIDE_04.png'
import SLIDE_05_0819 from 'pages_centennial/assets/0828/0819_SLIDE_05.png'
import SLIDE_06_0819 from 'pages_centennial/assets/0828/0819_SLIDE_06.png'
import SLIDE_07_0819 from 'pages_centennial/assets/0828/0819_SLIDE_07.png'
import SLIDE_08_0819 from 'pages_centennial/assets/0828/0819_SLIDE_08.png'
import SLIDE_09_0819 from 'pages_centennial/assets/0828/0819_SLIDE_09.png'
import SLIDE_10_0819 from 'pages_centennial/assets/0828/0819_SLIDE_10.png'
import SLIDE_11_0819 from 'pages_centennial/assets/0828/0819_SLIDE_11.png'
import SLIDE_12_0819 from 'pages_centennial/assets/0828/0819_SLIDE_12.png'

import crop_wm_cw_060 from 'pages_centennial/assets/0828/crop_wm_cw-060.png'
import IMG_today_tommorow_goddards from 'pages_centennial/assets/0901/today_tommorow_goddards_scaled.png'
import alpha_wm_cw_104 from 'pages_centennial/assets/ALPHA_wm_cw-104.png'

import IMG_today_goddards from 'pages_centennial/assets/0901/Bruce_McCandless_II_during_EVA_in_1984.jpg'

import GODDARD_IMAGE from 'pages_centennial/assets/0901/goddard.png'

// import GODDARD_ROCKET from 'pages_centennial/assets/0901/goddard_rocket.png'

import less_alpha_padding_logo from 'pages_centennial/assets/0901/less_alpha_padding_logo.png'

import OBELISK_0910 from 'pages_centennial/assets/0910/0910_OBELISK.png'


import IMG_01 from 'assets/video/01.png'
import IMG_02 from 'assets/video/02.png'
import IMG_03 from 'assets/video/03.png'
import IMG_04 from 'assets/video/04.png'
import IMG_05 from 'assets/video/05.png'
import IMG_06 from 'assets/video/06.png'
import IMG_07 from 'assets/video/07.png'
import IMG_08 from 'assets/video/08.png'
import IMG_09 from 'assets/video/wmp-177.png'
import IMG_WMP_127 from 'assets/video/wmp-127.png'

import IMG_WMP_219 from 'assets/video/wmp-219.png'
//import IMG_WMP_096 from 'assets/video/wmp-096_crop.png'
import IMG_WMP_096 from 'assets/video/wmp-096.png'


import IMG_WMP_071 from 'assets/video/wmp-071.png'
import IMG_WMP_001 from 'assets/video/wmp-001.png'































const CentennialPageRefactor = () => {





    const navigate = useNavigate();

    const handleLearnMoreClick = (url) => {
        console.log('click')
        if (url) {
            navigate(url);
        }
    };






    // 2. Updated function to handle both navigation and scrolling
    const handleNavigateAndScroll = (url) => {
        console.log('click and scroll');

        // --- SCROLL TO TOP LOGIC ---
        // Check if the ref is attached and has a scroll method (for a scrollable container)
        // OR, more reliably for the entire window/document:
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional: Makes the scroll smooth
        });

        // If the main div (pageRef.current) is the scrollable container, use this instead:
        // if (pageRef.current) {
        //     pageRef.current.scrollTo({
        //         top: 0,
        //         behavior: 'smooth'
        //     });
        // }
        // -----------------------------

        // 3. Perform the navigation after the scroll
        if (url) {
            // Use a short delay if scrolling the pageRef container to allow the DOM to update,
            // but for window.scrollTo, it's usually fine to run immediately.
            navigate(url);
        }
    };













    let subscriptionOptionsRenderArray = [
        {
            id: 1,
            name: 'test name',
            price: '0.00',
            stripe_reference_key: 'price_1S7N65KE0e1CFeGpTc6cJJI8',
            courses: [1, 2, 3]
        }
    ]


    let user_email = 'test@test.com'


    let index = 0





















    // Styles for the PARENT <div>
    const wrapperStyles = {
        // 1. Must define size (same as image height/width)
        width: '15rem',
        height: '15rem',

        // 2. Define the circular clip boundary
        borderRadius: '50%',
        overflow: 'hidden', // <-- CRITICAL for clipping the image

        // 3. Apply the crisp border (if desired)
        border: `1px solid rgba(21, 140, 196, 0.5)`,
        filter: `drop-shadow(0px 0px 8px rgba(21, 140, 196, 0.7)) drop-shadow(0px 0px 4px rgba(21, 140, 196, 0.7))`,

        // 4. If you absolutely need BOX-shadow (instead of filter), put it here
        // But since we are using filter below, we keep this clean:
        // boxShadow: '0 0 0 0' 
    };







    // Styles for the CHILD <img>
    const imageStyles = {
        // Stretch to fill the parent container's size (15rem x 15rem)
        width: '100%',
        height: '100%',

        // Ensures the image fills the area correctly without distortion
        objectFit: 'cover',

        // Apply the glow filter here (it respects the image's clipped shape)
        // filter: `drop-shadow(0px 0px 8px rgba(21, 140, 196, 0.7)) drop-shadow(0px 0px 4px rgba(21, 140, 196, 0.7))`,

        // NOTE: You don't need borderRadius on the image anymore, 
        // as the parent's overflow: hidden handles the clipping.
    };























    return (
        <PageWrapper navbarPermanent={true}>
            {/* <h1>test</h1> */}


            {/* <CollapsibleSectionNoBorder>
                </CollapsibleSectionNoBorder>

                <CollapsibleSectionNoBorderNoButton>
                </CollapsibleSectionNoBorderNoButton> */}








            {/* <div class="section_style">
                    <CollapsibleSectionNoBorder
                        title="Our Mission:"
                        summary="Inspiring our next generation."
                        imageSrc=''
                        imageAlt=""
                        fullText=" "
                        // learnMoreLink="/missionstatement"
                        // learnMoreText="Learn About The Wonder Mission"
                        delay={0.0}
                    >
                        <div>
                            <p style={{ fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', textAlign: 'justify' }}>
                                The Wonder Mission, a 501(c)(3) nonprofit organization,  was specifically founded to reverse this trend by launching a series of creative initiatives to help alter this troubling trend and inspire our next generation of those who dream big.
                            </p>
                            <p style={{ fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', textAlign: 'justify' }}>
                                The Mission aims to spark imagination and remind the public that anything is possible. As  Goddard once said: “It is difficult to say what is impossible, for the dream of yesterday is the hope of today and the reality of tomorrow.”
                            </p>
                            <p style={{ fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', textAlign: 'justify' }}>
                                The Wonder Mission invites everyone to dream big, explore boldly, and help shape a future where science and wonder are part of everyday life.
                            </p>
                        </div>
                    </CollapsibleSectionNoBorder>
                </div>
                
                
                // style={{ fontFamily: 'roboto_regular', fontSize: '1.2rem', maxWidth: '500px', color: colors.textColor, margin: '1rem' }}
                // 
                // */}





            <div style={{ marginTop: '4rem' }}>

            </div>




















            <div class="section_style">
                <h1

                    style={{
                        ...introHeadingStyles,
                        padding: '1rem',
                        margin: '1rem',
                        lineHeight: '2.5rem',
                        maxWidth: '800px',
                    }}

                >A word from The Wonder Mission's Executive Director, Charles Slatkin</h1>











                {/* <div style={wrapperStyles}>
                    <img
                        src={CHARLES_SLATKIN_IMAGE_2}
                        alt="CHARLES SLATKIN"
                        style={imageStyles}
                    />
                </div> */}













                <div

                    style={{

                        // boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`,
                        // border: `1px solid ${colors.accentColor}80`,
                        borderRadius: '50%',


                        // border: `1px solid rgba(21, 140, 196, 0.5)`,
                        // filter: `drop-shadow(0px 0px 8px rgba(21, 140, 196, 0.7)) drop-shadow(0px 0px 4px rgba(21, 140, 196, 0.7))`,



                    }}

                >


                    <img
                        src={CHARLES_SLATKIN_IMAGE_2}
                        alt="CHARLES SLATKIN"
                        style={{
                            width: 'auto',
                            height: '18rem', // Fixed height for the image
                            margin: '0rem', // Remove any default margins

                            // Add responsive image sizing if needed
                            maxWidth: '100%', // Ensure image doesn't overflow its container
                            objectFit: 'cover', // Or 'contain' depending on desired behavior

                            //boxShadow: `4px 4px 6px ${colors.accentColor}70`,


                            borderRadius: '50%',
                            /////boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: Centered, very blurry, slightly spread, more opaque
                            /////border: `1px solid ${colors.accentColor}80`,



                            border: `1px solid rgba(21, 140, 196, 0.5)`,
                            filter: `drop-shadow(0px 0px 8px rgba(21, 140, 196, 0.7)) drop-shadow(0px 0px 4px rgba(21, 140, 196, 0.7))`,
    

                            // --- NEW/MODIFIED: Fuzzy Shadow ---
                            //boxShadow: `0px 0px 20px 5px ${colors.accentColor}90`, // Example: Centered, very blurry, slightly spread, more opaque
                            //             ^  ^  ^    ^        ^
                            //             h  v  blur spread color (alpha)

                            // The border might make the shadow less fuzzy if it's very distinct.
                            // Consider removing or making the border very subtle if you want maximum fuzziness.
                            // border: `1px solid ${colors.accentColor}80`, // Keep or remove as desired

                        }}


                    />

                </div>

                <CollapsibleSection_01
                    title=""
                    summary=""
                    imageSrc=""
                    imageAlt=""
                    fullText=""
                    delay={0}
                    expanded={true}
                >
                    <div style={{ padding: '0rem', fontSize: '1.3rem', }}>
                        <p className="message_from_charles_class">
                            I was fortunate to have been inspired at a very early age by the wonders of science and space. As a child, I really did feel that “Anything Was Possible.” I still do. I want our kids and grandkids to feel the same way.
                        </p>
                        <p className="message_from_charles_class">
                            The Wonder Mission is my calling, and I am calling on you to bring your resources and passions to the effort, just as Robert Goddard did a century ago.
                        </p>
                        <p className="message_from_charles_class">
                            Together, we can once again spark the imaginations of young and old to the wonders of space, science, engineering, and the immense benefits to our country and the world.
                        </p>
                        <p className="message_from_charles_class">
                            Together, we can inspire our youth to be a part of something wondrous.
                        </p>
                        <p className="message_from_charles_class">
                            Reconnecting and leveraging Goddard’s vision and legacy will be the launch vehicle for our future.
                        </p>

                        <img
                            src={CHARLES_SLATKIN_SIGNATURE}
                            alt="SIGNATURE"
                            style={{
                                width: 'auto',
                                height: '5rem', // Fixed height for the image
                                margin: '0rem', // Remove any default margins
                                //borderRadius: '15%',
                                // Add responsive image sizing if needed
                                //maxWidth: '100%', // Ensure image doesn't overflow its container
                                objectFit: 'cover', // Or 'contain' depending on desired behavior
                            }}
                        />
                    </div>

                </CollapsibleSection_01>

                {/* <CollapsibleSection_01
                    title="title section which appears as bold and blue"
                    summary="summary section which appears as regular and white"
                    //imageSrc=''
                    imageAlt=""
                    fullText=" "
                    learnMoreLink="learnMoreLink"
                    learnMoreText="learnMoreText"
                    delay={0.0}
                >
                    <div style={{
                        //backgroundColor: 'gray',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                    >
                        <p style={{
                            width: '100%',
                            //backgroundColor: 'red',
                            fontSize: '1.3rem',
                            padding: '0rem',
                            margin: '1rem',
                            textAlign: 'left',
                        }}>
                            The dropdown menu can contain additional text.
                        </p>
                    </div>

                </CollapsibleSection_01> */}



            </div>












































            <div class="section_style">

                <div

                    class="glow_border_class_2"


                    style={{
                        margin: '1rem',
                        // padding: '10px',
                        borderRadius: '1rem',

                        border: `1px solid rgba(21, 140, 196, 0.5)`,
                        //filter: `drop-shadow(0px 0px 8px rgba(21, 140, 196, 0.7)) drop-shadow(0px 0px 4px rgba(21, 140, 196, 0.7))`,



                    }}

                >
                    <img
                        src={IMG_WMP_096}

                        // class="glow_border_class_2"


                        alt="The Wonder Mission Logo"
                        style={{
                            maxWidth: '90%',
                            width: '800px',
                            // maxHeight: '15rem',
                            // margin: '0px auto',
                            height: 'auto',
                            marginTop: '15px',
                            marginBottom: '15px',
                            // marginTop: '2rem',
                            // marginBottom: '2rem',
                            objectFit: 'contain',
                            //padding: '0.5rem',
                            //borderRadius: '1rem',
                        }}

                    />
                </div>


                <CollapsibleSection_01
                    title="Our Mission: Inspiring our next generation."
                    // summary="Our Mission:"
                    // summary2="Inspiring our next generation."
                    imageSrc=""
                    imageAlt=""
                    fullText=""
                    delay={0}
                    expanded={false}
                >



                    {/* <CollapsibleSectionNoBorder2
                    title="Our Mission:"
                    summary="Inspiring our next generation."
                    imageSrc=''
                    imageAlt=""
                    fullText=" "
                    // learnMoreLink="/missionstatement"
                    // learnMoreText="Learn About The Wonder Mission"
                    delay={0.0}
                > */}
                    <div>
                        {/* <p style={{ fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', textAlign: 'justify' }}>
                            The Wonder Mission, a 501(c)(3) nonprofit organization,  was specifically founded to reverse this trend by launching a series of creative initiatives to help alter this troubling trend and inspire our next generation of those who dream big.
                        </p>
                        <p style={{ fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', textAlign: 'justify' }}>
                            The Mission aims to spark imagination and remind the public that anything is possible. As  Goddard once said: “It is difficult to say what is impossible, for the dream of yesterday is the hope of today and the reality of tomorrow.”
                        </p>
                        <p style={{ fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', textAlign: 'justify' }}>
                            The Wonder Mission invites everyone to dream big, explore boldly, and help shape a future where science and wonder are part of everyday life.
                        </p> */}

                        <p

                            style={{
                                // fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', 
                                textAlign: 'justify'
                            }}

                        >
                            <span style={{ fontWeight: 'bold' }}>The Wonder Mission</span> - a 501(c)(3) nonprofit organization - creates transformative programs and experiences that spark curiosity and inspire the next generation of innovators, explorers, and dreamers: those who dare to dream boldly and help shape a brighter future.
                        </p>
                        <p

                            style={{
                                // fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', 
                                textAlign: 'justify'
                            }}

                        >
                            The "First Launch Centennial" and Dr. Robert Goddard's story embodies the very qualities we strive to promote—vision, perseverance, ingenuity, and invention. By sharing and celebrating his extraordinary legacy, we aim not only to honor his achievements but also to uplift the Goddards of today and tomorrow: the scientists, educators, students, engineers, innovators, and dreamers who are expanding the boundaries of knowledge for the betterment of humanity.
                        </p>

                        {/* — — */}













                    </div>
                </CollapsibleSection_01>
            </div>

































            <div class="section_style">
                <div >
                    <h1
                        class="intro_heading_style"
                        style={{ fontFamily: 'orbitron_medium', color: colors.accentColor, }}>
                        The Challenge</h1>
                </div>

                <div style={{
                    width: '100%',
                    maxWidth: '600px',
                    display: 'flex',
                    justifyContent: 'space-evenly'
                }}>



                    <div style={{

                        // border: `1px solid rgba(21, 140, 196, 0.5)`,
                        // filter: `drop-shadow(0px 0px 8px rgba(21, 140, 196, 0.7)) drop-shadow(0px 0px 4px rgba(21, 140, 196, 0.7))`,

                    }}>
                        <img
                            src={THE_CHALLENGE}
                            // class="glow_border_class"
                            style={{
                                maxWidth: '70%',
                                //maxHeight: '15rem',
                                //margin: '2rem',
                                padding: '0rem',
                                width: 'auto',
                                height: 'auto',
                                borderRadius: '50%',
                                objectFit: 'contain',
                                // boxShadow: `1px 4px 10px ${colors.cardBorder}43`,
                                // border: `1px solid ${colors.cardBorder}80`,

                                border: `1px solid rgba(21, 140, 196, 0.5)`,
                                filter: `drop-shadow(0px 0px 8px rgba(21, 140, 196, 0.7)) drop-shadow(0px 0px 4px rgba(21, 140, 196, 0.7))`,


                            }}
                        />
                    </div>




                </div>


                {/* <img
                        src={THE_CHALLENGE}
                        alt="The Wonder Mission Logo"
                        class="glow_border_class"
                        style={{
                            maxWidth: '90%',
                            maxHeight: '15rem',
                            margin: '0px auto',
                            width: 'auto',
                            height: 'auto',
                            // borderRadius: '4px',
                            // borderRadius: '3rem',
                            borderRadius: '50%',
                            objectFit: 'contain',
                            boxShadow: `1px 4px 10px ${colors.cardBorder}43`,
                            border: `1px solid ${colors.cardBorder}80`,
                        }}
                    /> */}



                <CollapsibleSection_01
                    title="Reigniting a Passion for WONDER and AWE"
                    summary=""
                    imageSrc=''
                    imageAlt=""
                    fullText=" "
                    learnMoreLink=""
                    learnMoreText=""
                    delay={0.0}
                >
                    <div>



                        <p >
                            Shockingly, the U.S. is falling behind other developed nations in graduating science and engineering majors.
                        </p>

                        {/* <p style={{ fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', }}>
                                Shockingly, the U.S. has fallen to 38th in the world in graduating science and engineering majors.
                            </p> */}

                        <p >
                            More than 1.5 million STEM jobs go unfulfilled due to a lack of qualified talent.
                        </p>


                        {/* <p style={{ fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', textAlign:'center', }}>
                                Despite best efforts, STEM has been a harder sell than expected.
                            </p> */}


                        <p >
                            Countries like China think generationally are outpacing us in R&D, Artificial Intelligence, science education, and critical technology research.
                        </p>
                    </div>
                </CollapsibleSection_01>


            </div>






































            {/* <div class="section_style">

                <p class="p_style_01">
                    An Initiative of
                </p>

                <p class="p_style_01"
                    style={{ backgroundColor: 'rgba(25, 171, 240,0.20)', padding: '1rem', borderRadius: '1rem', cursor: 'pointer' }}
                    onClick={() => handleLearnMoreClick('/about')}
                >
                    <b>The Wonder Mission</b>
                </p>


                <h3 style={{ color: colors.accentColor, margin: '1rem' }}>Subscribe to Our Newsletter!</h3>
                <div style={{ borderRadius: '2rem', margin: '1rem' }}>

                    <NewsletterForm>

                    </NewsletterForm>
                </div>
            </div> */}



            <div class="section_style">


                {/* <div >
                        <h1
                            class="intro_heading_style"
                            style={{ fontFamily: 'orbitron_medium', color: colors.accentColor, }}>
                           Robert Goddard</h1>
                    </div>


                    <p style={{ fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', }}>
                        Surprisingly most people don't know who Robert Goddard was or what he accomplished
                        (Blurb on Robert Goddard)
                    </p> */}


                <div >
                    <h1
                        class="intro_heading_style"
                        style={{ fontFamily: 'orbitron_medium', color: colors.accentColor, }}>
                        Robert Goddard</h1>
                </div>

                <div style={{
                    width: '100%',
                    maxWidth: '600px',
                    display: 'flex',
                    justifyContent: 'space-evenly'
                }}>

                    <img
                        src={GODDARD_IMAGE}
                        // class="glow_border_class"
                        style={{
                            maxWidth: '70%',
                            //maxHeight: '15rem',
                            margin: '2rem',
                            padding: '0rem',
                            width: 'auto',
                            height: 'auto',
                            borderRadius: '50%',
                            objectFit: 'contain',
                            // boxShadow: `1px 4px 10px ${colors.cardBorder}43`,
                            // border: `1px solid ${colors.cardBorder}80`,

                            border: `1px solid rgba(21, 140, 196, 0.5)`,
                            filter: `drop-shadow(0px 0px 8px rgba(21, 140, 196, 0.7)) drop-shadow(0px 0px 4px rgba(21, 140, 196, 0.7))`,


                        }}
                    />

                </div>

                {/* <img
                        src={GODDARD_IMAGE}
                        alt="The Wonder Mission Logo"
                        class="glow_border_class"
                        style={{
                            maxWidth: '90%',
                            maxHeight: '15rem',
                            margin: '0px auto',
                            width: 'auto',
                            height: 'auto',
                            // borderRadius: '4px',
                            // borderRadius: '3rem',
                            borderRadius: '50%',
                            objectFit: 'contain',
                            boxShadow: `1px 4px 10px ${colors.cardBorder}43`,
                            border: `1px solid ${colors.cardBorder}80`,
                        }}
                    /> */}

                {/* <CollapsibleSectionNoBorder
                        title="Robert Goddard"
                        summary="Surprisingly most people don't know who Robert Goddard was or what he accomplished
                        (Blurb on Robert Goddard)"
                        imageSrc={GODDARD_IMAGE}
                        learnMoreLink="/robertgoddard"
                        learnMoreText="Goddard Biography"
                        delay={0.0}
                    > */}



                <div style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center'
                }}>














                    {/* <CollapsibleSection_01
                        title="Reigniting a Passion for WONDER and AWE"
                        summary=""
                        imageSrc=''
                        imageAlt=""
                        fullText=" "
                        learnMoreLink=""
                        learnMoreText=""
                        delay={0.0}
                        expanded={true}
                    >
                        <div>



                            <p style={{ textAlign: 'center' }}>
                                Surprisingly most people don't know who Robert Goddard was or what he accomplished.
                            </p>

                            <p style={{ textAlign: 'center' }}>
                                Goddard's story is an inspirational one of vision, perseverance, discipline, and focus in pursuit of the dream of space exploration.
                            </p>

                        </div>


                    </CollapsibleSection_01> */}


























                    <CollapsibleSection_01
                        title=""
                        summary=""
                        imageSrc=""
                        imageAlt=""
                        fullText=""
                        delay={0}
                        expanded={true}
                    >
                        <div>

                            <p style={{ textAlign: 'center', }}>
                                Surprisingly most people don't know who Robert Goddard was or what he accomplished.
                            </p>

                            <p style={{ textAlign: 'center' }}>
                                Goddard's story is an inspirational one of vision, perseverance, discipline, and focus in pursuit of the dream of space exploration.
                            </p>



                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}>
                                <div

                                    onClick={() => handleNavigateAndScroll('/robertgoddard')}

                                    className="div_link_button"

                                    style={{
                                        border: `1px solid rgba(21, 140, 196, 0.5)`,
                                        // filter: `drop-shadow(0px 0px 8px rgba(21, 140, 196, 0.7))`,

                                    }}

                                >



                                    {/* <p

                                    // onClick={() => handleNavigateClick('/')}


                                    // style={{
                                    //   color: 'white',
                                    //   fontSize: '2rem',
                                    //   fontWeight: 'bold',
                                    //   fontFamily: 'orbitron',
                                    //   backgroundColor: 'rgba(25, 171, 240,0.20)',
                                    //   padding: '1rem',
                                    //   margin: '1rem',
                                    //   borderRadius: '1rem',
                                    //   cursor:'pointer',
                                    // }}

                                    >More about Dr. Goddard, father of the space age.</p> */}


                                    <p
                                        style={{
                                            //backgroundColor: 'rgba(25, 171, 240,0.20)',
                                            padding: '0rem',
                                            margin: '0.5rem',
                                            fontWeight: 'bold',
                                            fontSize: '1.1rem',
                                            fontFamily: 'roboto_regular',
                                            color: colors.accentColor,
                                        }}
                                    >Click here to learn more about </p>
                                    <p
                                        style={{
                                            //backgroundColor: 'rgba(25, 171, 240,0.20)',
                                            padding: '0rem',
                                            margin: '0.5rem',
                                            fontSize: '1.5rem',
                                            //letterSpacing:'0.1rem',
                                            fontFamily: 'orbitron_regular'
                                        }}
                                    >Dr. Robert H. Goddard</p>
                                    <p
                                        style={{
                                            //backgroundColor: 'rgba(25, 171, 240,0.20)',
                                            padding: '0rem',
                                            margin: '0.5rem',

                                            fontFamily: 'roboto_regular',
                                            color: colors.accentColor,
                                        }}
                                    >Father of the Space Age</p>


                                </div>

                            </div>


                        </div>
                    </CollapsibleSection_01>







                    {/* <CollapsibleSection_01
                        title=""
                        // summary="Surprisingly most people don't know who Robert Goddard was or what he accomplished."
                        summary=""
                        imageSrc=""
                        imageAlt=""
                        // learnMoreLink="/robertgoddard"
                        // learnMoreText="More about Dr. Goddard, father of the space age."
                        delay={0.0}
                        expanded={true}
                    >

                        <div>

                            <p style={{ textAlign: 'center' }}>
                                Surprisingly most people don't know who Robert Goddard was or what he accomplished.
                            </p>

                            <p style={{ textAlign: 'center' }}>
                                Goddard's story is an inspirational one of vision, perseverance, discipline, and focus in pursuit of the dream of space exploration.
                            </p>

                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}>
                                <p
                                    className="div_link_button"
                                    // onClick={() => handleNavigateClick('/')}

                                    onClick={() => handleNavigateAndScroll('/robertgoddard')}
                                // style={{
                                //   color: 'white',
                                //   fontSize: '2rem',
                                //   fontWeight: 'bold',
                                //   fontFamily: 'orbitron',
                                //   backgroundColor: 'rgba(25, 171, 240,0.20)',
                                //   padding: '1rem',
                                //   margin: '1rem',
                                //   borderRadius: '1rem',
                                //   cursor:'pointer',
                                // }}

                                >More about Dr. Goddard, father of the space age.</p>
                            </div>

                        </div>

                    </CollapsibleSection_01> */}

















                </div>

                {/* <div>
                        <p style={{ fontFamily: 'roboto_regular', fontSize: '1.3rem', color: colors.accentColor, fontWeight: 'bold', marginTop: '1rem', }}>
                            Goddard's story is an inspirational one of vision, perseverance, discipline, and focus in pursuit of the dream of space exploration.
                        </p>
                    </div> */}



            </div>

















































            <div class="section_style">
                <div >
                    <h1
                        class="intro_heading_style"
                        style={{ fontFamily: 'orbitron_medium', color: colors.accentColor, }}>
                        Today's and Tomorrow's Goddard's</h1>
                </div>

                {/* IMG_WMP_219 */}



                <div style={{
                    width: '100%',
                    maxWidth: '800px',
                    display: 'flex',
                    justifyContent: 'space-evenly'
                }}>




                    <img
                        src={IMG_today_goddards}
                        alt="The Wonder Mission Logo"
                        //class="glow_border_class"
                        style={{
                            maxWidth: '40%',
                            // maxHeight: '15rem',
                            margin: '10px',
                            width: 'auto',
                            height: 'auto',
                            borderRadius: '50%',
                            objectFit: 'contain',
                            // boxShadow: `1px 4px 10px ${colors.cardBorder}43`,
                            // border: `1px solid ${colors.cardBorder}80`,
                            border: `1px solid rgba(21, 140, 196, 0.5)`,
                            filter: `drop-shadow(0px 0px 8px rgba(21, 140, 196, 0.7)) drop-shadow(0px 0px 4px rgba(21, 140, 196, 0.7))`,

                        }}
                    />

                    <img
                        src={IMG_today_tommorow_goddards}
                        alt="The Wonder Mission Logo"
                        //class="glow_border_class"
                        style={{
                            maxWidth: '40%',
                            // maxHeight: '15rem',
                            margin: '10px',
                            width: 'auto',
                            height: 'auto',
                            borderRadius: '50%',
                            objectFit: 'cover',
                            // boxShadow: `1px 4px 10px ${colors.cardBorder}43`,
                            // border: `1px solid ${colors.cardBorder}80`,
                            border: `1px solid rgba(21, 140, 196, 0.5)`,
                            filter: `drop-shadow(0px 0px 8px rgba(21, 140, 196, 0.7)) drop-shadow(0px 0px 4px rgba(21, 140, 196, 0.7))`,

                        }}
                    />



                </div>







                <CollapsibleSection_01
                    title=""
                    summary=""
                    imageSrc=""
                    imageAlt=""
                    fullText=""
                    delay={0}
                    expanded={true}
                >
                    <div>

                        <p >
                            As important as it is to celebrate Goddard’s legacy and historic achievement, its even more critical that we simultaneously celebrate our own modern day “Today's and Tomorrow's Goddards.”
                        </p>
                        <p >
                            “Today's Goddards” are our scientists, engineers, innovators, explorers, and educators who dream big, work tirelessly to expand human knowledge and receive little public acknowledgement or notoriety.
                        </p>
                        <p >
                            It's critical we also  inspire, elevate and celebrate our "Tomorrow's Goddards."
                        </p>


                    </div>
                </CollapsibleSection_01>
























                {/* <CollapsibleSectionNoBorderCenter
                    // title="Todays and Tomorrows Innovators"
                    summary=""
                    //"Today's and Tomorrow's Innovators"
                    imageSrc=''
                    imageAlt=""
                    fullText=" "
                    learnMoreLink=""
                    learnMoreText=""
                    delay={0.0}
                >
                    <div>
                        <p>
                                As important as it is to celebrate Goddard’s legacy and historic achievement, its even more critical that we simultaneously celebrate our own modern day “Goddards.”
                            </p> 
                        <p style={{ fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', textAlign: 'center' }}>
                            As important as it is to celebrate Goddard’s legacy and historic achievement, its even more critical that we simultaneously celebrate our own modern day “Today's and Tomorrow's Goddards.”
                        </p>
                        <p style={{ fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', textAlign: 'center' }}>
                            “Today's Goddards” are our scientists, engineers, innovators, explorers, and educators who dream big, work tirelessly to expand human knowledge and receive little public acknowledgement or notoriety.
                        </p>
                        <p style={{ fontSize: '1.3rem', maxWidth: '90%', padding: '1rem', textAlign: 'center' }}>
                            It's critical we also  inspire, elevate and celebrate our "Tomorrow's Goddards."
                        </p>
                    </div>
                </CollapsibleSectionNoBorderCenter> */}

            </div>










































































            {/* <div class="section_style">
            </div> */}






































            <div class="section_style">

                <DonateComponent></DonateComponent>

            </div>

















































            {/* <div class="section_style">

                <h3 style={{ color: colors.accentColor, margin: '1rem' }}>Subscribe to Our Newsletter!</h3>
                <div style={{ borderRadius: '2rem', margin: '1rem' }}>

                    <NewsletterForm>

                    </NewsletterForm>
                </div>
            </div> */}

































            {/* // As  Goddard once said: “It is difficult to say what is impossible, for the dream of yesterday is the hope of today and the reality of tomorrow. */}
            {/* <div class="section_style">
                <CollapsibleSection_01
                    title="title section which appears as bold and blue"
                    summary="summary section which appears as regular and white"
                    //imageSrc=''
                    imageAlt=""
                    fullText=" "
                    learnMoreLink="learnMoreLink"
                    learnMoreText="learnMoreText"
                    delay={0.0}
                >
                    <div style={{
                        //backgroundColor: 'gray',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                    >
                        <p style={{
                            width: '100%',
                            //backgroundColor: 'red',
                            fontSize: '1.3rem',
                            padding: '0rem',
                            margin: '1rem',
                            textAlign: 'left',
                        }}>
                            The dropdown menu can contain additional text.
                        </p>
                    </div>



                </CollapsibleSection_01>
            </div> */}






        </PageWrapper >
    )

}

export default CentennialPageRefactor;

